import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { BACKGROUND_GRAY, LINE_GRAY } from '../colors';
import { getMs, getPx } from '../helpers/common';
import { isDefined } from '../helpers/defined';
import { size as sizeStyle } from '../style/size';
import { height as heightStyle } from '../style/height';
import { width as widthStyle } from '../style/width';
const SKELETON_BASE_COLOR = LINE_GRAY;
const SKELETON_HIGHLIGHT_COLOR = BACKGROUND_GRAY;
const SKELETON_BACKGROUND_SIZE = '400px';
const SKELETON_ANGLE = '90deg';
const slide = keyframes`
  100% {
    transform: translateX(calc(${getPx(SKELETON_BACKGROUND_SIZE)} + 150%));
  }
`;
const Wrapper = styled.div`
  width: 100%;
  ${({
  $size
}) => $size && sizeStyle($size)}
  ${({
  $width
}) => $width && widthStyle($width)}
  ${({
  $height
}) => $height && heightStyle($height)}
`;
const SkeletonElement = styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${({
  $colorBase
}) => $colorBase};
  border-radius: ${({
  $rounded,
  $circle
}) => $circle ? '50%' : $rounded ? '4px' : 'inherit'};
  display: ${({
  $single = false
}) => $single ? 'block' : 'inline-block'};
  line-height: 1;
  width: 100%;
  z-index: 1;

  ${({
  $size
}) => $size && sizeStyle($size)}
  ${({
  $width
}) => $width && widthStyle($width)}
  ${({
  $height
}) => $height && heightStyle($height)}
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${SKELETON_BACKGROUND_SIZE};
    height: 100%;
    z-index: 0;
    transform: translateX(-${getPx(SKELETON_BACKGROUND_SIZE)});
    background-color: ${({
  $colorBase
}) => $colorBase};
    background-image: ${({
  $colorBase,
  $colorHighlight
}) => `linear-gradient(${SKELETON_ANGLE}, ${$colorBase}, ${$colorHighlight}, ${$colorBase})`};
    background-repeat: no-repeat;
    ${({
  $duration
}) => css`
        animation: ${slide} ${getMs($duration)} ease-in-out infinite;
      `}
  }
`;
const Skeleton = ({
  count,
  itemHeight,
  duration = 1200,
  size,
  width,
  height,
  widthRandomness = 0.25,
  rounded = true,
  circle = false,
  colorBase = SKELETON_BASE_COLOR,
  colorHighlight = SKELETON_HIGHLIGHT_COLOR,
  ...props
}) => {
  if (!isDefined(count)) {
    return /*#__PURE__*/React.createElement(SkeletonElement, _extends({
      $single: true,
      $duration: duration,
      $size: size,
      $width: width,
      $height: height,
      $rounded: rounded,
      $circle: circle,
      $colorBase: colorBase,
      $colorHighlight: colorHighlight
    }, props));
  }
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $size: size,
    $width: width,
    $height: height
  }, props), Array(count).fill(undefined).map((v, idx) => {
    const width = `${(1 - widthRandomness + Math.random() * widthRandomness) * 100}%`;
    return /*#__PURE__*/React.createElement(SkeletonElement, {
      key: idx,
      $height: itemHeight,
      $duration: duration,
      $width: width,
      $rounded: rounded,
      $circle: circle,
      $colorBase: colorBase,
      $colorHighlight: colorHighlight
    }, "\u200C");
  }));
};
export default Skeleton;